import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  CircularProgress,
  Button,
  ButtonBase,
  Box,
} from "@material-ui/core";

import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import ContentEditor from "./ContentEditor";

import { useAlert } from "../../components/Alert";
import LoadingModal from "../../components/LoadingModal";
import { Card, CardActions, CardContent } from "../../components/Card";
import { Select, TextInput } from "../../components/Form";
import { identity } from "../../components/utils";

const GET_ARTICLE = gql`
  query article($id: Int!) {
    article(id: $id) {
      id
      title
      imageUrl
      type
      contents {
        type
        body
      }
    }
  }
`;

const SAVE_ARTICLE = gql`
  mutation saveArticle($articleInput: ArticleInput!) {
    saveArticle(articleInput: $articleInput)
  }
`;
const UPLOAD_IMAGE = gql`
  mutation UploadImage($image: Upload!) {
    uploadImage(image: $image) {
      filename
      mimetype
      encoding
      location
    }
  }
`;

export default function NewInfoForm({ id, onChangeSelect = () => {} }) {
  //const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const Alert = useAlert();
  const [title, setTitle] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [contents, setContents] = useState({
    contents: [],
  });
  const typeArray = [
    {
      label: "媒體報導",
      value: "MEDIA_COVERAGE",
    },
    {
      label: "富屋榮耀",
      value: "GLORY",
    },
    {
      label: "富屋豹報",
      value: "ANNOUNCEMENT",
    },
  ];
  const [typeObject, setTypeObject] = useState({});
  const [getArticle, { loading }] = useLazyQuery(GET_ARTICLE, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted({ article }) {
      if (article) {
        let newArticle = [];
        article.contents.map(({ __typename, ...item }) => {
          newArticle.push(item);
        });
        setTitle(article.title);
        setImageUrl(article.imageUrl);
        setTypeObject({ label: getType(article.type), value: article.type });
        setContents({ contents: newArticle });
      }
    },
    onError(error) {
      Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
    },
  });

  const [uploadImage, { loading: uploadImageLoading }] = useMutation(
    UPLOAD_IMAGE,
    {
      onCompleted({ uploadImage }) {
        delete uploadImage.__typename;
        setImageUrl(uploadImage.location);
      },
      onError(error) {
        return Alert.notice(`${error}`);
      },
    }
  );
  useEffect(() => {
    if (Boolean(id)) {
      getArticle({ variables: { id } });
    } else {
      setTitle("");
      setImageUrl("");
      setTypeObject({
        label: "媒體報導",
        value: "MEDIA_COVERAGE",
      });
      setContents({ contents: [] });
    }
  }, [id]);

  function _saveArticle() {
    const detailsNull = contents.contents.find(
      (item) =>
        (item.type === "HEADING" && item.body === "") ||
        (item.type === "PARAGRAPH" && item.body === "") ||
        (item.type === "IMAGE" && item.body === "") ||
        (item.type === "VIDEO" && item.body === "")
    );

    if (!Boolean(title)) {
      return Alert.alert("", "標題未填寫！", [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    }

    if (detailsNull) {
      return Alert.alert("", "最新消息未填寫完！", [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    }
    if (Boolean(id)) {
      saveArticle({
        variables: {
          articleInput: {
            id,
            title,
            imageUrl,
            contents: contents.contents,
            type: typeObject.value,
          },
        },
      });
    } else {
      saveArticle({
        variables: {
          articleInput: {
            title,
            imageUrl,
            contents: contents.contents,
            type: typeObject.value,
          },
        },
      });
    }
  }

  const [saveArticle, { loading: saveArticleLoading }] = useMutation(
    SAVE_ARTICLE,
    {
      onCompleted({ saveArticle }) {
        if (saveArticle) {
          Alert.alert("", "儲存成功", [
            {
              text: "確定",
              onPress: () => {
                onChangeSelect();
              },
              type: "ok",
            },
          ]);
        } else {
          Alert.alert("", "儲存失敗，請再次嘗試。", [
            { text: "確定", type: "ok" },
          ]);
        }
      },
      onError(error) {
        Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
      },
    }
  );
  function getType(value) {
    switch (value) {
      case "MEDIA_COVERAGE":
        return "媒體報導";
      case "GLORY":
        return "富屋榮耀";
      case "ANNOUNCEMENT":
        return "富屋豹報";
      default:
        return null;
    }
  }
  if (loading) {
    return (
      <Grid container justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else if (identity) {
    return (
      <Card>
        <LoadingModal loading={saveArticleLoading || uploadImageLoading} />
        <CardContent>
          <Grid container spacing={1}>
            <Grid item sm={6} xs={6}>
              <TextInput
                value={title}
                onChange={(v) => setTitle(v)}
                label="標題"
                fullWidth
              />
            </Grid>
            <Grid item sm={6} xs={6}>
              <Select
                label="類別"
                items={typeArray}
                value={typeObject}
                onChange={(e, v) => {
                  setTypeObject(v);
                }}
              />
            </Grid>
            {"\u2002"}
          </Grid>
          <Grid container spacing={1}>
            <Grid item sm={12} xs={12}>
              <Typography>封面</Typography>
              <Box
                display="flex"
                flex={1}
                justifyContent="center"
                alignItems="center"
              >
                <ButtonBase
                  style={{ flex: 1, height: 300 }}
                  component="label"
                  htmlFor={"coverImage"}
                >
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <CloudUploadIcon />
                  )}
                </ButtonBase>
                <>
                  <input
                    id={"coverImage"}
                    type="file"
                    accept="image/*"
                    onChange={(event) => {
                      const {
                        target: {
                          validity,
                          files: [file],
                        },
                      } = event;

                      if (validity.valid) {
                        uploadImage({ variables: { image: file } });
                      }
                    }}
                    style={{
                      display: "none",
                    }}
                  />
                </>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
        <CardContent>
          <ContentEditor
            data={contents}
            onChangeData={(e) => setContents({ contents: e })}
          />
        </CardContent>
        {contents.contents[0] && (
          <CardActions>
            <Grid container item justify="flex-end">
              <Button
                variant="contained"
                color="primary"
                onClick={() => _saveArticle()}
              >
                儲存
              </Button>
            </Grid>
          </CardActions>
        )}
      </Card>
    );
  } else {
    return (
      <Card>
        <LoadingModal loading={saveArticleLoading || uploadImageLoading} />
        <CardContent>
          <Grid container spacing={1}>
            <Grid item sm={6} xs={6}>
              <Typography color="primary">標題</Typography>
              <Typography>{title}</Typography>
            </Grid>
            <Grid item sm={6} xs={6}>
              <Typography color="primary">類別</Typography>
              <Typography>{typeObject.label}</Typography>
            </Grid>
            {"\u2002"}
          </Grid>
          <Grid container spacing={1}>
            <Grid item sm={12} xs={12}>
              <Typography color="primary">封面</Typography>
              <Box
                display="flex"
                flex={1}
                justifyContent="center"
                alignItems="center"
              >
                <ButtonBase
                  style={{ flex: 1, height: 300 }}
                  component="label"
                  disabled
                >
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <CloudUploadIcon />
                  )}
                </ButtonBase>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
        <CardContent>
          <ContentEditor
            edit={false}
            data={contents}
            onChangeData={(e) => setContents({ contents: e })}
          />
        </CardContent>
      </Card>
    );
  }
}
